export default "__VITE_ASSET__CEp0fcjH__"